var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Editor',{staticStyle:{"min-height":"450px"},attrs:{"api-key":"i1jx4840k173k43ppts9j8n99resujrgz0hwy2lu4dyq28tw","value":_vm.content,"init":{
    plugins: 'lists link image table code help wordcount',
    menubar: 'file edit view insert format tools table help',
    toolbar: 'undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help',
    browser_spellcheck: true,
    contextmenu: false,
    auto_focus: true,
    branding: false,
    statusbar: true,
    resize: true,
  }},on:{"input":_vm.updateContent}})}
var staticRenderFns = []

export { render, staticRenderFns }